(function (angular, app) {
    'use strict';

    app.directive('customizeSpCheckbox', ['$timeout', function ($timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                model: '=',
                onChange: '&?spChange',
                disabled: '=?spDisabled',
                iName: '@?',

                checkboxText: '@?',

                additionalText: '@?',
                maxWords: '=?',
                // iSpInlineError: '=?',
                // iSpInlineErrorAttachToParent: '@?'
            },
            templateUrl: 'template/directives/customize-sp-checkbox/index.html',
            controllerAs: 'customizeSpCheckboxCtrl',
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
                var customizeSpCheckboxCtrl = this;

                _init();

                function _init() {
                    $scope.showFullLegalText = false;
                    $scope.shouldUseShortAdditionalText = false;

                    if ($scope.additionalText && $scope.maxWords) {
                        $scope.shortAdditionalText = truncateTextByWords($scope.additionalText, $scope.maxWords);
                        $scope.shouldUseShortAdditionalText = $scope.additionalText !== $scope.shortAdditionalText;
                    }
                }

                function truncateTextByWords(text, maxWords) {
                    if (!text || !maxWords) {
                        return text;
                    }
                    
                    var words = text.trim().split(/\s+/);
                    if (words.length <= maxWords) {
                        return text;
                    }

                    return words.slice(0, maxWords).join(' ');
                }
            }]
        };
    }]);
})(angular, app);